import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import PricingContext from '~/contexts/PricingContext';
import { useHasAppliedTrade } from '~/contexts/SearchContext';

const useTradeToggled = () => {
  const hasAppliedTrade = useHasAppliedTrade();
  const { setShouldUpdateTerms } = useContext(PricingContext);

  useSubsequentEffect(() => {
    setShouldUpdateTerms(true);
  }, [hasAppliedTrade, setShouldUpdateTerms]);
};

export default useTradeToggled;
